import {createRef, FC, useContext, useEffect, useRef, useState} from "react";
import {SessionUserContext} from "../context/UserContext";
// @ts-ignore
import MeasureTool from 'measuretool-googlemaps-v3';
import {getRandomHighlightColor, sqMtrsToSqFt} from "../utils";

const containerStyle = {
    width: '100%',
    height: '500px'
};

const init_center = {
    lat: -3.745,
    lng: -38.523
};

type Props = {
    onConfirmAreaSelection: (area: number) => void
}

const GoogleMapsAreaSelector: FC<Props> = ({onConfirmAreaSelection}) => {
    const {location, polygons, setPolygons} = useContext(SessionUserContext)

    const mapElementRef = createRef<HTMLDivElement>()
    const mapRef = useRef<google.maps.Map>()
    const shapesRef = useRef<any>({})
    const drawingManagerRef = useRef<any>()
    const [storedPaths, setStoredPaths] = useState<any>({})

    useEffect(() => {
        setPolygons(storedPaths)
    }, [storedPaths, setPolygons]);


    const recreatePolygonsFromStoredData = (polygons: any, map: google.maps.Map) => {


        Object.keys(polygons).map(id => {
            if (polygons.hasOwnProperty(id)) {
                var pathData = polygons[id].paths;
                // Create an array to store the LatLng objects
                var path = [];

                // Populate the path array with LatLng objects from the stored data
                for (var i = 0; i < pathData.length; i++) {
                    var latLng = new google.maps.LatLng(pathData[i].lat, pathData[i].lng);
                    path.push(latLng);
                }

                // Create a new polygon using the path array
                shapesRef.current[id] = new google.maps.Polygon({
                    paths: path,
                    fillColor: polygons[id].color,
                    editable: true, // Allow the user to edit the polygon
                    map: map // Add the polygon to the map
                });

            }
        })
    }


    useEffect(() => {
        if (location && mapElementRef?.current && !mapRef.current) {

            const options: google.maps.MapOptions = {

                center: location.geometry.location,
                zoom: 20,
                mapTypeId: 'satellite',
                tilt: 0,
                rotateControl: false,
                streetViewControl: false,
                mapTypeControl: false,
            }

            mapRef.current = new google.maps.Map(mapElementRef.current, options);


            drawingManagerRef.current = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYGON,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: [google.maps.drawing.OverlayType.POLYGON]
                },
                polygonOptions: {
                    editable: true
                }
            });
            drawingManagerRef.current.setMap(mapRef.current);


            if (mapRef.current && polygons && Object.keys(polygons).length > 0) {

                recreatePolygonsFromStoredData(polygons, mapRef.current)
                setTimeout(() => {
                    const totalArea = Object.keys(polygons).reduce((acc, key) => {
                        // @ts-ignore
                        return acc + google.maps.geometry.spherical.computeArea(polygons[key].paths)
                    }, 0)

                    setStoredPaths(polygons)
                    onConfirmAreaSelection(sqMtrsToSqFt(totalArea))
                }, 2000)

            }


            google.maps.event.addListener(drawingManagerRef.current, "overlaycomplete", function (event: any) {
                if (event.type == google.maps.drawing.OverlayType.POLYGON) {
                    var polygon: google.maps.Polygon = event.overlay;
                    const color = getRandomHighlightColor()
                    polygon.setOptions({
                        fillColor: color
                    })
                    // Generate a unique identifier for the polygon
                    var id = 'polygon_' + Math.random().toString(36).substr(2, 9);
                    shapesRef.current[id] = polygon;
                    onConfirmAreaSelection(0)

                    setStoredPaths((storedPaths: any) => {
                        return {
                            ...storedPaths,
                            [id]: {
                                color: color,
                                paths: polygon.getPath().getArray().map(function (coord: {
                                    lat: () => any;
                                    lng: () => any;
                                }) {
                                    return {lat: coord.lat(), lng: coord.lng()};
                                })
                            }
                        }

                    })


                    // Attach event listeners for polygon changes
                    google.maps.event.addListener(polygon.getPath(), 'set_at', function () {
                        onConfirmAreaSelection(0)
                        setStoredPaths((storedPaths: any) => {
                            return {
                                ...storedPaths,
                                [id]: {
                                    color: color,
                                    paths: polygon.getPath().getArray().map(function (coord: {
                                        lat: () => any;
                                        lng: () => any;
                                    }) {
                                        return {lat: coord.lat(), lng: coord.lng()};
                                    })
                                }
                            }

                        })
                    });

                    google.maps.event.addListener(polygon.getPath(), 'insert_at', function () {
                        onConfirmAreaSelection(0)

                        setStoredPaths((storedPaths: any) => {
                            return {
                                ...storedPaths,
                                [id]: {
                                    color: color,
                                    paths: polygon.getPath().getArray().map(function (coord: {
                                        lat: () => any;
                                        lng: () => any;
                                    }) {
                                        return {lat: coord.lat(), lng: coord.lng()};
                                    })
                                }
                            }

                        })
                    });

                    google.maps.event.addListener(polygon.getPath(), 'remove_at', function () {
                        onConfirmAreaSelection(0)

                        setStoredPaths((storedPaths: any) => {
                            return {
                                ...storedPaths,
                                [id]: {
                                    color: color,
                                    paths: polygon.getPath().getArray().map(function (coord: {
                                        lat: () => any;
                                        lng: () => any;
                                    }) {
                                        return {lat: coord.lat(), lng: coord.lng()};
                                    })
                                }
                            }

                        })
                    });
                }
            });


        }

    }, [location, mapElementRef, mapRef])


    return (
        <div className={"uk-section uk-section-small"}>
            <hr/>
            <div className={"step-block"}>
                <span>Step 2:</span> Select your lawn area
            </div>
            <h3 className={"uk-margin-remove"}>
                Select the area(s) of your lawn.
            </h3>
            <p className={"uk-margin-small-top"}>
                Start by clicking  on the map to start drawing a shape. You can select multiple areas.
            </p>
            <div className="uk-grid uk-child-width-expand@m uk-grid-small" data-uk-grid>
                <div>
                    <div style={containerStyle} ref={mapElementRef}>

                    </div>
                    <div className={"uk-padding-small uk-background-muted"}>
                        <button className={"uk-button uk-button-small"} onClick={() => {
                            Object.keys(shapesRef.current).forEach((key) => {
                                shapesRef.current[key].setMap(null)
                            })
                            setStoredPaths({})
                            onConfirmAreaSelection(0)
                        }}>
                            <div data-uk-icon={"icon:close;ratio:.8"}></div>
                            Clear Shapes
                        </button>
                    </div>
                </div>
                <div className={"uk-width-1-4@m"}>
                    <div className="uk-card uk-card-default uk-card-body uk-card-small">
                        <ul className={"uk-list"}>
                            {Object.keys(storedPaths).map((key) => {
                                return (
                                    <li className={"uk-flex uk-flex-middle"}>

                                            <span className={"uk-label uk-margin-small-right"} style={{
                                                background: storedPaths[key].color,
                                                width: '20px',
                                                height: 20
                                            }}></span>

                                        {sqMtrsToSqFt(google.maps.geometry.spherical.computeArea(storedPaths[key].paths))} sq.
                                        ft.

                                    </li>
                                )
                            })}
                        </ul>
                        {Object.keys(storedPaths).length > 0 && <div className="uk-card-footer">
                            <button className={"uk-button uk-button-small uk-button-secondary uk-width-1-1"}
                                    onClick={() => {
                                        const totalArea = Object.keys(storedPaths).reduce((acc, key) => {
                                            return acc + google.maps.geometry.spherical.computeArea(storedPaths[key].paths)
                                        }, 0)
                                        onConfirmAreaSelection(sqMtrsToSqFt(totalArea))
                                    }}>Confirm Area
                            </button>
                        </div>}
                    </div>
                </div>

            </div>


        </div>)

}

export default GoogleMapsAreaSelector